import React, { useContext } from "react";
import { ClientContext } from "../../context/Client/ClientContext";

const DepartmentList = ({ departmentList, handleDeptClick }) => {
  const { selectedDepartment } = useContext(ClientContext);

  const handleClick = (dept) => {
    handleDeptClick(dept.id);
  };

  return (
    <div className="gog-dept-picker-list">
      <div className="gog-dept-picker-header">
        <span>Step 1</span>
        <h4>Categories</h4>
        <p>Select the main business category.</p>
      </div>

      <div className="gog-dept-picker-items">
        {departmentList && departmentList.length > 0 ? (
          departmentList.map((dept) => {
            const isSelected = selectedDepartment === dept.id;

            return (
              <button
                key={dept.id}
                type="button"
                className={`gog-dept-picker-item ${
                  isSelected ? "active" : ""
                }`}
                onClick={() => handleClick(dept)}
              >
                <span>{dept.name}</span>
                {isSelected && <b>✓</b>}
              </button>
            );
          })
        ) : (
          <div className="gog-dept-empty">No categories available.</div>
        )}
      </div>
    </div>
  );
};

export default DepartmentList;